import { BUSINESS_CENTER_SUBTYPE_CODE, WAREHOUSE_TYPES, SHOWROOM_REGION_CODE } from "./constants.js";
const getWarehouseType = (warehouse) => {
  var _a;
  if (((_a = warehouse.subType) == null ? void 0 : _a.code) === BUSINESS_CENTER_SUBTYPE_CODE) {
    return WAREHOUSE_TYPES.BUSINESS_CENTER;
  } else if (warehouse.regionCode === SHOWROOM_REGION_CODE) {
    return WAREHOUSE_TYPES.SHOWROOM;
  } else {
    return WAREHOUSE_TYPES.STANDARD;
  }
};
export {
  getWarehouseType
};
